import {LOADING, LOADED} from '../actions/loading'

export default function valentine(state = {}, action = {}) {
  switch (action.type) {
    case LOADED:
      return action.valentine
    default:
      return state
  }
}

